<template>
  <div
    role="dialog"
    class="modal fade"
    id="incoming-call-dialog"
    tabindex="-1"
    :aria-hidden="isDialogVisible"
    v-show="isDialogVisible"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="usr-info">
            <img
              class="usr-pho"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png"
            />
            <p class="usr-name">未知来电</p>
            <p class="incoming-call-tip">邀请您通话</p>
          </div>
          <div class="op-btns">
            <div class="incoming-call-reject">
              <img
                @click="hangUp()"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
              />
              <p class="op-txt">挂断</p>
            </div>
            <div class="incoming-call-video">
              <img
                @click="answer(0)"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433226356/videoCall.png"
              />
              <p class="op-txt">视频通话</p>
            </div>
            <div class="incoming-call-audio">
              <img
                @click="answer(1)"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433255465/audioCall.png"
              />
              <p class="op-txt">语音通话</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rejectCall, answerCall } from '@/utils/duerService';
export default {
  data() {
    return {
      isDialogVisible: false,
    };
  },
  methods: {
    // 显示弹窗（返回 Promise）
    show() {
      this.isDialogVisible = true;
    },
    // 隐藏弹窗
    hide() {
      this.isDialogVisible = false;
    },
    // 挂断
    hangUp() {
      rejectCall();
    },
    // 接听（0-视频，1-语音）
    answer(mode) {
      answerCall(mode);
    },
  },
};
</script>

<style scoped>
#login-form,
#device-form {
  width: 500px;
  margin: 20px auto 20px;
}
.usr-info {
  text-align: center;
}
.usr-pho {
  margin-top: 35px;
  width: 120px;
  height: 120px;
}
.usr-name {
  margin-top: 10px;
  font-weight: 500;
  font-size: 30px;
  line-height: 42px;
  color: #fafafa;
}
.incoming-call-tip {
  font-size: 16px;
  line-height: 22px;
  color: #666666;
}
.op-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.op-btns img {
  width: 80px;
  height: 80px;
  margin: 24px 80px;
  cursor: pointer;
}
.op-txt {
  line-height: 20px;
  text-align: center;
  color: #fafafa;
}
#outing-call-view,
#call-view {
  position: fixed;
  width: 50%;
  height: 55%;
  right: 22%;
  top: 22%;
  z-index: 10052;
  background: #080808cf;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
#outing-call-view .op-btns {
  margin-top: 50px;
}
.peer-pho {
  width: 104px;
  height: 104px;
  margin-top: 50px;
}
.peer-name {
  font-size: 60px;
  line-height: 86px;
}
.outing-call-tip {
  font-size: 42px;
  line-height: 60px;
  color: rgba(225, 225, 225, 0.5);
}
#call-view .op-btns {
  position: absolute;
  bottom: 50px;
}
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.main-view video {
  width: 100%;
  object-fit: fill;
}
.main-view .audio-name {
  margin-top: 100px;
  font-size: 62px;
  line-height: 87px;
}
.main-view .audio-call {
  font-size: 36px;
  line-height: 50px;
  color: rgba(225, 225, 225, 0.5);
  margin-top: 17px;
}
.main-view .audio-tip-wrap {
  position: absolute;
  top: 0;
}
.sub-view {
  width: 320px;
  height: 192px;
  position: absolute;
  left: 48px;
  top: 48px;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  z-index: 1;
}
.sub-view video {
  width: 320px;
  height: 192px;
  object-fit: fill;
}
.sub-view .audio-tip-wrap {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.sub-view .audio-name {
  font-size: 48px;
  line-height: 67px;
  max-width: 300px;
}
.sub-view .audio-call {
  font-size: 24px;
  line-height: 34px;
  text-align: right;
}
#message-alert {
  position: fixed;
  z-index: 1053;
  width: 300px;
  right: 0;
  top: 10px;
  display: none;
}
.desc-title {
  text-align: center;
  margin-bottom: 20px;
}
.modal {
  background: #121213eb;
  width: 50%;
  height: 40%;
  position: fixed;
  right: 22%;
  top: 18%;
}
</style>
